module.exports = __webpack_public_path__ + "img/woman.867361a8.png";